import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'

import { alertActions, loaderActions, regisActions, certificateActions } from '../../../store/actions'
import history from '../../../route/history'
import Input from '../../../module/input/CustomInput'
import { regConstants } from '../../../store/constants'
import validPassword from '../../../hook/valid/password'
import { commons } from '../../../hook/common'

const RegisUserStep2 = (props) => {
  // 본인인증popup open 여부

  const [state, setState] = useState({
    isZipOpen: false,
    isCompanyZipOpen: false,
    submitted: false,
    isJoin: false, //가입여부체크
    checkedId: false, //아이디 중복체크
    checkedRegistNo: false, //사업자번호 정상체크
    uthInfo: '',
  })

  const nodeBaseInfo = {
    memberId: {
      className: 'form-keyword',
      wrapperClassWidth: 'inherit',
      type: 'text',
      title: '담당자 아이디',
      message: '담당자 아이디를 입력하세요.',
      placeholder: '담당자 아이디를 입력하세요.',
      required: true,
      length: 30,
      regex: regConstants.id,
      regErrMsg: '담당자 아이디는 4~30자 영어 대소문자, 숫자만 입력 가능합니다.',
      withBtn: true,
      withBtnName: '중복체크',
      withBtnClick: () => validId('memberId', ''),
    },
    passwd: {
      className: 'form-keyword',
      type: 'password',
      title: '비밀번호',
      message: '비밀번호를 입력하세요.',
      placeholder: '비밀번호를 입력하세요.',
      required: true,
      length: 20,
      regex: regConstants.pwd,
      regErrMsg: '비밀번호 유효형식 정의 필요합니다.', //FIXME
    },
    passwdAgain: {
      className: 'form-keyword',
      type: 'password',
      title: '비밀번호',
      message: '비밀번호를 다시 입력하세요.',
      placeholder: '비밀번호를 다시 입력하세요.',
      required: true,
      length: 20,
      regex: regConstants.pwd,
      regErrMsg: '비밀번호 유효형식 정의 필요합니다.', //FIXME
    },
    memberName: {
      className: 'form-keyword disabled',
      wrapperClassWidth: 'inherit',
      type: 'text',
      title: '이름',
      // message: '이름을 입력하세요',
      // placeholder: '이름을 입력하세요',
      // required: true,
      readOnly: true,
      length: 15,
    },
    groupDept: {
      type: 'text',
      title: '부서 및 직급',
      message: '부서를 입력하세요.',
      placeholder: '부서를 입력하세요.',
      className: 'm-r-4',
      length: 100,
    },
    groupClsf: {
      type: 'text',
      inputTitle: '직급',
      message: '직급을 입력하세요.',
      placeholder: '직급을 입력하세요.',
      length: 100,
    },
    email: {
      className: 'form-keyword',
      type: 'text',
      title: '이메일',
      message: '이메일을 입력하세요',
      placeholder: '이메일을 입력하세요',
      required: true,
      length: 100,
      regex: regConstants.email,
      regErrMsg: '이메일 주소 형식이 아닙니다.',
    },

    mobileNo: {
      className: 'form-keyword disabled',
      wrapperClassWidth: 'inherit',
      type: 'text',
      title: '휴대폰 번호',
      message: '본인인증',
      readOnly: true,
      length: 20,
    },
  }

  // 사용자 가입용 데이터
  const [userInfo, setUserInfo] = useState({
    almEmailYn: 'N',
    almKakaoYn: 'N',
    almSmsYn: 'N',
    almPushYn: 'N',
    userSeCd: '', // 담당자구분-A : 업무관리자 - N : 업무담당자
    mobileCertDt: '' /* 핸드폰 번호 */,
    certCi: '' /* 핸드폰 CI값 */,
    ktnetCertYn: 'Y',
    joinSeCd: '',
  })

  const [nodeInfo, setNodeInfo] = useState(nodeBaseInfo)
  const inputRef = React.useRef(new Array(Object.keys(nodeBaseInfo).length))

  /**
   * 약관동의 체크
   */
  useEffect(() => {
    let agreeInfo = props.location.state?.agreeInfo
    let stateUserInfo = props.location.state?.userInfo

    let obj = {}

    if (!agreeInfo) {
      history.replace('/regis')
      return
    }

    Object.keys(agreeInfo).forEach((key) => {
      obj[key] = agreeInfo[key]?.agree === true ? 'Y' : 'N'
    })

    setUserInfo({
      ...userInfo,
      ...stateUserInfo,
      ...obj,
    })

    if (!props.certName || !props.cellNo) {
      history.replace('/regis')
    }
    commons.preventKeyDown()
    return () => {
      // 본인인증 정보 초기화
      props.setInitialState()
    }
  }, [])

  /** MOBILE_NO(휴대폰번호), CERT_CI(인증 CI값) 중복체크 */
  useEffect(() => {
    if (props.checkMobileYn != null) {
      if (!props.checkMobileYn) {
        props.success({
          title: '돌아가기',
          message: '해당 휴대폰 번호로 가입된 사용자가 존재합니다.',
          params: {
            type: 'ERROR',
            callback: () => {
              // 본인인증 정보 초기화
              props.setInitialState()
              history.replace({ pathname: '/regis/user' })
            },
          },
        })
      }
    }
  }, [props.checkMobileYn])

  //담당자 아이디 정보 갱신
  useEffect(() => {
    let obj = {
      withBtnClick: () => validId('memberId', userInfo?.memberId),
    }

    if (props.checkedId === true) {
      props.checkResetId()
      obj.withBtnName = '중복체크'
    }

    handleChangeNode('memberId', obj)
  }, [userInfo?.memberId])

  //담당자 중복체크 콜백
  useEffect(() => {
    if (props.checkedId === true) {
      props.success({
        title: '담당자 아이디',
        message: '사용 가능한 아이디입니다.',
      })

      handleChangeNode('memberId', {
        errMessage: null,
        withBtnName: '확인완료',
        withBtnClick: () => validId('memberId', userInfo?.memberId),
      })
    } else {
      handleChangeNode('memberId', {
        withBtnName: '중복체크',
        withBtnClick: () => validId('memberId', userInfo?.memberId),
      })
    }
  }, [props.checkedId])

  //가입완료처리
  useEffect(() => {
    if (props.isJoin === true) {
      // history.push({ pathname: '/regis/success/' + userInfo?.memberId })
      history.push({ pathname: '/regis/RegisUserStep3/' + userInfo?.memberId })
    }
  }, [props.isJoin])

  // 본인인증 받은 cellNo userInfo정보 넣기 위함
  useEffect(() => {
    setUserInfo((userInfo) => ({
      ...userInfo,
      mobileNo: props.cellNo,
    }))
  }, [props.cellNo])

  useEffect(() => {
    setUserInfo((userInfo) => ({
      ...userInfo,
      mobileCertDt: props.certDate,
    }))
  }, [props.certDate])

  useEffect(() => {
    setUserInfo((userInfo) => ({
      ...userInfo,
      certCi: props.certCi,
    }))
  }, [props.certCi])

  useEffect(() => {
    setUserInfo((userInfo) => ({
      ...userInfo,
      memberName: props.certName,
    }))
  }, [props.certName])

  useEffect(() => {
    setUserInfo((userInfo) => ({
      ...userInfo,
      nativeYn: props.fgnGbn === '1' ? 'Y' : 'N', // 1-내국인, 2-외국인
    }))
  }, [props.fgnGbn])

  useEffect(() => {
    setUserInfo((userInfo) => ({
      ...userInfo,
      genderCd: props.sex,
    }))
  }, [props.sex])

  useEffect(() => {
    setUserInfo((userInfo) => ({
      ...userInfo,
      birthDay: props.birYMD,
    }))
  }, [props.birYMD])

  /**
   * 아이디 중복체크
   * @param key :사업자아이디, 이용자 아이디
   * @param value
   */
  const validId = (key, value) => {
    if (value?.length === undefined) {
      return props.error({ message: '담당자 아이디를 입력하세요.' })
    }
    if (value?.length < 4) {
      return props.error({ message: '아이디는 최소 4자리 이상입니다.' })
    }

    if (key === 'memberId') {
      if (!props.checkedId) {
        nodeInfo[key]?.regex.test(value) ? props.checkMemberId(value) : props.error({ message: nodeInfo[key]?.regErrMsg })
      }
    }
  }

  /**
   * 다음화면 진입전 유효성 체크
   */
  const goNext = () => {
    setState({ ...state, submitted: !state.submitted })

    let node = nodeInfo
    let errCnt = 0
    let isFocus = false
    Object.keys(node).forEach((key, index) => {
      let message = null

      //필수 체크
      if (node[key].required) {
        if (!userInfo?.[key] || userInfo?.[key]?.length <= 0) {
          message = node[key]?.message
          errCnt++
        }
      }

      //유효성 체크
      if (message === null && userInfo?.[key]?.length > 0 && !!node[key].regex) {
        let regex = node[key].regex
        let value = userInfo?.[key]
        let regResult = regex.test(value)

        if (!regResult) {
          message = node[key]?.regErrMsg
          errCnt++
        } else {
          message = null
        }
      }

      //비밀번호 유효성 체크
      if (key === 'passwd') {
        let pwdError = validPassword({ password: userInfo.passwd, id: userInfo.memberId })
        if (pwdError && pwdError?.length > 0) {
          message = pwdError
          errCnt++
        }
      }

      // 휴대폰번호 본인인증 인증 필수체크
      if (key === 'mobileNo') {
        if (!userInfo.mobileNo) {
          message = node[key]?.regErrMsg
        } else {
          message = null
        }
      }

      if (errCnt === 1 && key === 'mobileNo') {
        if (!userInfo.mobileNo) {
          return props.error({ message: '휴대폰 번호 본인인증이 인증되지 않았습니다.\n 본인인증을 진행해주세요.' })
        }
      }
      // 휴대폰번호 본인인증 인증 끝
      node[key].errMessage = message

      if (!isFocus && errCnt === 1) {
        isFocus = true
        inputRef.current[index].focus()
      }
    })

    if (errCnt > 0) {
      return
    } else {
      if (!props.checkedId) {
        return props.error({ message: '담당자 아이디 중복체크를 해주세요.' })
      }

      if (userInfo.passwd !== userInfo.passwdAgain) {
        return props.error({ message: '비밀번호가 일치하지 않습니다.\n 다시 확인해주세요.' })
      }
    }

    props.registUser(userInfo)
  }

  /**
   * 화면 표시된 node의 정보변경
   * @param nodeKey
   * @param changeObj
   */
  const handleChangeNode = (nodeKey, changeObj) => {
    setNodeInfo((nodeInfo) => ({
      ...nodeInfo,
      [nodeKey]: {
        ...nodeInfo?.[nodeKey],
        ...changeObj,
      },
    }))
  }

  /**
   * 가입용 사용자정보
   * @param e
   */
  const handleChange = (e) => {
    const { id, value } = e.target

    setUserInfo({
      ...userInfo,
      [id]: value,
    })
  }

  const checkHandler = (e) => {
    const { id, checked } = e.target

    setUserInfo({
      ...userInfo,
      [id]: checked === true ? 'Y' : 'N',
    })
  }

  /**
   * 인풋태그 자동생성
   * @param key
   * @returns {JSX.Element}
   */
  const generateInput = (key) => {
    let className = ''
    const node = nodeInfo[key]
    let idx = Object.keys(nodeInfo).indexOf(key)
    return (
      <Input
        type={node.type}
        className={className + (node.className != undefined ? ' ' + node.className : '')}
        wrapperClassWidth={node.wrapperClassWidth}
        id={key}
        name={key}
        // title={node.title}
        inputTitle={node?.inputTitle ? node?.inputTitle : node?.title}
        autoComplete="off"
        value={userInfo?.[key] || ''}
        placeholder={node.placeholder}
        ref={(ref) => (inputRef.current[idx] = ref)}
        wrapperClassName={node.wrapperClassName}
        message={node.message}
        flow={node.flow ? node.flow : `${window.innerWidth >= 767 ? 'left' : 'up'}`}
        required={node.required}
        onChange={handleChange}
        readOnly={node.readOnly}
        length={node.length}
        withBtn={node.withBtn}
        withBtnName={node.withBtnName}
        withBtnClick={node.withBtnClick}
        submitted={state.submitted}
        errMessage={node.errMessage}
      />
    )
  }

  return (
    <React.Fragment>
      <div id="contents">
        <div className="content-header type2">
          {/* mobile 뒤로가기 버튼 */}
          <a
            onClick={(e) => {
              e.preventDefault()
              window.history.back()
            }}
            className="page-prev"
          >
            뒤로이동
          </a>
          <h2>회원가입</h2>
          <div className="breadcrumb">
            <span>Home</span>
            <em>회원가입</em>
          </div>
        </div>
        <div className="join-wrap">
          <ul className="steps">
            <li>
              <span className="num">1</span>약관동의
            </li>
            <li>
              <span className="num">2</span>본인인증
            </li>
            <li className="on">
              <span className="num">3</span>회원정보 입력
            </li>
            <li>
              <span className="num">4</span>가입완료
            </li>
          </ul>
          <h3 className="h3-tit">담당자 회원가입</h3>
          <p className="required">* 표시는 필수 입력사항입니다.</p>
          <table className="tbl-write">
            <caption>아이디, 비밀번호, 비밀번호 확인, 이름, 부서 및 직급, 이메일, 휴대폰 번호 항목으로 구성</caption>
            <colgroup>
              <col className="col1" />
              <col />
            </colgroup>
            <tbody>
              <tr>
                <th scope="row">
                  <em className="required" /> 아이디
                </th>
                <td>
                  <span className="inquiry-group">
                    {generateInput('memberId')} {/* 아이디 */}
                  </span>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <em className="required" /> 비밀번호
                </th>
                <td>
                  {generateInput('passwd')} {/* 비밀번호 */}
                  <p className="desc">
                    ※ 영문, 숫자, 특수문자 중 2종류를 조합 10~16자 (3종류 8~16자리)로 설정
                    {/* <br /> ※ 특수문자는 숫자 키보드 위의 [!@#$%^&amp;*_+{'}'}만 가능 */}
                  </p>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <em className="required" /> 비밀번호 확인
                </th>
                <td>
                  {generateInput('passwdAgain')} {/* 비밀번호 확인 */}
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <em className="required" /> 이름
                </th>
                <td>
                  {generateInput('memberName')} {/* 이름 */}
                </td>
              </tr>
              {/* InvtId가 있을 경우 부서 및 직급 */}
              {userInfo.invtId && (
                <tr>
                  <th scope="row">부서 및 직급</th>
                  <td>
                    <span className="input-group">
                      {generateInput('groupDept')} {/* 부서 */}
                      {generateInput('groupClsf')} {/* 직급 */}
                    </span>
                  </td>
                </tr>
              )}
              <tr>
                <th scope="row">
                  <em className="required" /> 이메일
                </th>
                <td>
                  {generateInput('email')} {/* 이메일 */}
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <em className="required" /> 휴대폰 번호
                </th>
                <td>
                  <span className="inquiry-group">
                    {generateInput('mobileNo')} {/* 핸드폰번호 */}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
          <h3 className="h3-tit">알람 수신 동의 (선택)</h3>
          <div className="check-box">
            <span className="check-group">
              <input title="이메일 수신동의" type="checkbox" id="almEmailYn" onChange={checkHandler} />
              <em />
              <label htmlFor="almEmailYn">E-mail 수신 동의</label>
              <input title="알람톡 수신동의" type="checkbox" id="almKakaoYn" onChange={checkHandler} />
              <em />
              <label htmlFor="almKakaoYn">알람톡 수신 동의</label>
              <input title="SMS 수신동의" type="checkbox" id="almSmsYn" onChange={checkHandler} />
              <em />
              <label htmlFor="almSmsYn">SMS 수신 동의</label>
            </span>
          </div>
          <div className="btn-block center">
            <a className="btn-primary lg cursor cursor" onClick={goNext}>
              다음 단계로
            </a>
          </div>
        </div>
      </div>
      {/* <Alert /> */}
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    user: state.regis,
    isJoin: state.regis.isJoin,
    checkedId: state.regis.checkedId,
    checkMobileYn: state.regis.checkMobileYn,
    cellNo: state.certificate.resultInfo.cellNo,
    certDate: state.certificate.resultInfo.certDate,
    certCi: state.certificate.resultInfo.ci1,
    certName: state.certificate.resultInfo.name,
    fgnGbn: state.certificate.resultInfo.fgnGbn,
    sex: state.certificate.resultInfo.sex,
    birYMD: state.certificate.resultInfo.birYMD,
  }
}

const actionCreators = {
  registUser: regisActions.registUser,
  checkMemberId: regisActions.checkMemberId,
  checkResetGroupId: regisActions.checkResetGroupId,
  checkResetId: regisActions.checkResetId,
  loading: loaderActions.loading,
  error: alertActions.info,
  success: alertActions.success,
  setInitialState: certificateActions.setInitialState,
}

export default connect(mapStateToProps, actionCreators)(RegisUserStep2)
